import { isEmptyOrNil } from '@/utils'
import { Tooltip } from 'antd'
import { isEmpty } from 'radash'
import { useEffect, useRef, useState } from 'react'
import CountUp from 'react-countup'

const MeCountUp = ({
  end = 1000,
  duration = 2,
  separator = ',',
  decimal = '.',
  decimals = 0,
  prefix = '',
  suffix = '',
  showTooltip = false,
  originNum = '',
}: {
  end?: number | string
  duration?: number
  separator?: string
  decimal?: string
  decimals?: number
  prefix?: string
  suffix?: string
  showTooltip?: boolean
  originNum?: number | string
}) => {
  const [start, setStart] = useState<number | string>(0)
  const isSetStart = useRef(false)
  useEffect(() => {
    if (isEmptyOrNil(end) || end === '-') return
    if (isSetStart.current) {
      setStart(getEnd)
    } else {
      isSetStart.current = true
    }
  }, [end])
  if (isEmpty(end)) return '-'
  const getEnd = () => {
    if (isEmptyOrNil(end) || end === '-') return 0
    let newEnd = end.toString()
    if (newEnd.includes(',')) {
      newEnd = newEnd.split(',').join('')
    }
    return Number(newEnd)
  }
  return (
    <Tooltip placement="top" title={showTooltip && <div>{originNum}</div>}>
      <div>
        <CountUp
          start={start as number}
          end={getEnd()}
          duration={duration}
          separator={separator}
          decimal={decimal}
          decimals={decimals}
          prefix={prefix}
          suffix={suffix}
        />
      </div>
    </Tooltip>
  )
}

export default MeCountUp
